import React, { useEffect, useState } from "react";

import FormRow from "../../ui/FormRow";
import { useCurrentUser } from "../authentication/useCurrentUser";
import { useUpdateUser } from "./useUpdateUser";
import toast from "react-hot-toast";
import { ColorRing } from "react-loader-spinner";
import FileInputPreview from "../../ui/FileInputPreview";
import { getImageUrl } from "../../services/api";
const Userdata = ({ inModal = false }) => {
  const { user } = useCurrentUser();
  const { update, isUpdating } = useUpdateUser();
  const email = user?.email;

  // Form State
  const [formData, setFormData] = useState({
    name: user?.name || user?.user_metadata?.name || "",
    phone: user?.phone || "",
    bio: user?.bio || "",
    country: user?.country || "",
    city: user?.city || "",
    state: user?.state || "",
    postalCode: user?.postalCode || "",
    taxId: user?.taxId || ""
  });
  const [avatar, setAvatar] = useState(null);
  const [errors, setErrors] = useState({});

  // Sync state with user data
  useEffect(() => {
    setFormData({
      name: user?.name || user?.user_metadata?.name || "",
      phone: user?.phone || "",
      bio: user?.bio || "",
      country: user?.country || "",
      city: user?.city || "",
      state: user?.state || "",
      postalCode: user?.postalCode || "",
      taxId: user?.taxId || ""
    });
  }, [user]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors(prev => ({ ...prev, [name]: undefined }));
  };

  const validate = () => {
    const nextErrors = {};
    if (!formData.name.trim()) {
      nextErrors.name = "Name is required";
    }
    if (formData.phone.trim() && !/^[+\d][\d\s\-()]{6,}$/.test(formData.phone.trim())) {
      nextErrors.phone = "Please enter a valid phone number";
    }
    setErrors(nextErrors);
    return Object.keys(nextErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!validate()) return;

    const avatarSize = avatar && avatar?.size;
    const isLessImage = avatarSize / 1000 <= 1000 || null;

    if (avatar && !isLessImage) {
      toast.error("image should be less than 1mb");
      // e.target.reset(); // Don't reset everything on image error
      return;
    }

    update(
      { ...formData, avatar },
      {
        onSuccess: () => {
          toast.success("Account setting updated successfully.");
          // e.target.reset(); // Don't reset, keep values
        },
      },
    );
  };

  const handleCancel = () => {
    setFormData({
      name: user?.name || user?.user_metadata?.name || "",
      phone: user?.phone || "",
      bio: user?.bio || "",
      country: user?.country || "",
      city: user?.city || "",
      state: user?.state || "",
      postalCode: user?.postalCode || "",
      taxId: user?.taxId || ""
    });
    setAvatar(null);
    setErrors({});
  };

  const InputClass = "input-bordered input-info input w-full bg-gray-100 font-medium text-zinc-500 disabled:border-none disabled:bg-gray-400 disabled:text-gray-700 dark:bg-zinc-800 dark:text-gray-300 dark:disabled:text-gray-200";

  return (
    <div className={inModal ? "w-full" : "mx-auto max-w-2xl py-8"}>
      <form
        onSubmit={handleSubmit}
        className={inModal ? "grid grid-cols-1 gap-6" : "grid grid-cols-1 gap-8 rounded-xl p-6 shadow-sm dark:shadow-shadowOne"}
      >
        {!inModal && (
          <h2 className="text-center text-lg font-bold capitalize text-sky-500 dark:text-sky-300">
            Modify your data
          </h2>
        )}

        <div className="grid gap-6 md:grid-cols-2">
          <FormRow lable={"Email"} col={1}>
            <input
              type="email"
              value={email}
              disabled
              className="input-bordered input-info input w-full bg-white text-zinc-500 disabled:border-none disabled:bg-gray-200 disabled:text-gray-500 dark:bg-zinc-800 dark:disabled:text-gray-500"
            />
          </FormRow>

          <FormRow lable={"Full Name"} col={1} error={errors.name}>
            <input
              type="text"
              name="name"
              value={formData.name}
              disabled={isUpdating}
              onChange={handleChange}
              className={InputClass}
            />
          </FormRow>

          <FormRow lable={"Phone"} col={1} error={errors.phone}>
            <input
              type="text"
              name="phone"
              value={formData.phone}
              disabled={isUpdating}
              onChange={handleChange}
              placeholder="+1 234 567 890"
              className={InputClass}
            />
          </FormRow>

          <FormRow lable={"Tax ID"} col={1}>
            <input
              type="text"
              name="taxId"
              value={formData.taxId}
              disabled={isUpdating}
              onChange={handleChange}
              placeholder="Tax-123456"
              className={InputClass}
            />
          </FormRow>

          <div className="md:col-span-2">
            <FormRow lable={"Bio"} col={1}>
              <textarea
                name="bio"
                value={formData.bio}
                disabled={isUpdating}
                onChange={handleChange}
                rows="3"
                className="textarea textarea-bordered textarea-info w-full bg-gray-100 font-medium text-zinc-500 disabled:border-none disabled:bg-gray-400 disabled:text-gray-700 dark:bg-zinc-800 dark:text-gray-300 dark:disabled:text-gray-200"
              ></textarea>
            </FormRow>
          </div>
        </div>

        <h4 className="border-b border-gray-200 pb-2 text-sm font-bold text-gray-500 dark:border-gray-700 dark:text-gray-400">Address Details</h4>

        <div className="grid gap-6 md:grid-cols-2">
          <FormRow lable={"Country"} col={1}>
            <input
              type="text"
              name="country"
              value={formData.country}
              disabled={isUpdating}
              onChange={handleChange}
              className={InputClass}
            />
          </FormRow>
          <FormRow lable={"City"} col={1}>
            <input
              type="text"
              name="city"
              value={formData.city}
              disabled={isUpdating}
              onChange={handleChange}
              className={InputClass}
            />
          </FormRow>
          <FormRow lable={"State"} col={1}>
            <input
              type="text"
              name="state"
              value={formData.state}
              disabled={isUpdating}
              onChange={handleChange}
              className={InputClass}
            />
          </FormRow>
          <FormRow lable={"Postal Code"} col={1}>
            <input
              type="text"
              name="postalCode"
              value={formData.postalCode}
              disabled={isUpdating}
              onChange={handleChange}
              className={InputClass}
            />
          </FormRow>
        </div>

        <FormRow lable={"Photo"} col={1}>
          <FileInputPreview
            registerProps={{ onChange: (e) => setAvatar(e.target.files[0]) }}
            existingImageUrl={user?.avatar ? getImageUrl(user.avatar) : null}
            disabled={isUpdating}
            previewClassName="mb-3 h-16 w-16 rounded-full object-cover"
            inputClassName="file-input-bordered file-input-accent file-input file-input-md w-full bg-gray-300 text-black sm:file-input-md dark:bg-white"
          />
        </FormRow>

        <div className="mt-8 flex gap-3 justify-self-end">
          <button
            disabled={isUpdating}
            type="submit"
            className="group relative flex min-w-[8rem] items-center justify-center overflow-hidden rounded-lg bg-gradient-to-r from-primary to-secondary px-6 py-2.5 font-medium text-white shadow-md transition-all duration-300 hover:-translate-y-0.5 hover:shadow-lg hover:shadow-primary/30 active:translate-y-0 active:scale-95 disabled:opacity-75"
          >
            <span className="relative z-10 flex items-center gap-2">
              {isUpdating ? (
                <ColorRing
                  height={24}
                  width={24}
                  colors={["#ffffff", "#ffffff", "#ffffff", "#ffffff", "#ffffff"]}
                />
              ) : (
                "Update"
              )}
            </span>
            <div className="absolute inset-0 z-0 bg-gradient-to-l from-primary to-secondary opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
          </button>
          <button
            type="button"
            disabled={isUpdating}
            onClick={handleCancel}
            className="flex justify-center rounded-lg border border-stroke px-6 py-2.5 font-medium text-black hover:shadow-1 active:scale-95 disabled:opacity-50 dark:border-strokedark dark:text-white"
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default Userdata;
